const criticityLabels = {
  NEUF: "Neuf",
  NORMAL: "Normal",
  URGENT: "Urgent",
  HYPER_URGENT: "Hyper urgent",
  CRITIQUE: "Critique"
};

const stateLabels = {
  REMISE: "Remise",
  EMISE: "Émise",
  REJETE: "Rejeté",
  ACCEPTE: "Accepté",
  NOUVEAU: "Nouveau",
  TERMINE: "Terminé",
  EN_COURS: "En cours",
  CLOTURE: "Clôturé",
  ANNULE: "Annulé",
  ACCOMPLI: "Accompli",
  NO_ACCOMPLI: "Non accompli",
  ASSIGNE: "Assigné",
  NO_ASSIGNE: "Non assigné"
};

export const getCriticityColor = (value) => {
  switch (value) {
   
    case "ACTIF":
    case "REMISE":
      return "success";

    case "URGENT":
    case "INACTIF":
    case "EN_COURS":
      return "warning";
      
    case "NORMAL":
    case "NOUVEAU":
      return "primary";

    case "HYPER_URGENT":
    case "CRITIQUE":
      return "danger";

    default:
      return "secondary";
  }
};
export const getStateColor = (value) => {
  switch (value) {
    case "ACCEPTE":
    case "ASSIGNE":
    case "ACCOMPLI":
    
    case "ACTIF":
    case "REMISE":
      return "success";

    case "INACTIF":
    case "EN_COURS":
      return "warning";

    case "REJETE":
    case "NO_ASSIGNE":
    case "NO_ACCOMPLI":
    case "ANNULE":
      return "danger";

    case "NOUVEAU":
    case "EMISE":
      return "primary";

    case "TERMINE":
    case "CLOTURE":
      return "info";

    default:
      return "secondary";
  }
};

export const mapToAntDColor = (color) => {
  switch (color) {
    case "primary":
      return "blue";
    case "success":
      return "green";
    case "warning":
      return "orange";
    case "danger":
      return "red";
    case "secondary":
    default:
      return "default";
  }
};

export const formatCriticity = (value) => criticityLabels[value] || value;
export const formatState = (value) => stateLabels[value] || value;